import { useEffect, useRef, useState } from 'react';

export type UseCyclicVariantOptions = {
  periodMs?: number;
  startIndex?: number;
};

export const useCyclicVariant = (
  totalVariants: number,
  { periodMs = 2000, startIndex = 0 }: UseCyclicVariantOptions = {},
) => {
  const [index, setIndex] = useState(startIndex);
  const timerIdRef = useRef<NodeJS.Timer | null>(null);

  useEffect(() => {
    if (!totalVariants) {
      return;
    }

    timerIdRef.current = setInterval(() => {
      setIndex((prev) => (prev + 1) % totalVariants);
    }, periodMs);

    return () => {
      if (timerIdRef.current) {
        clearInterval(timerIdRef.current);
        timerIdRef.current = null;
      }
    };
  }, [totalVariants, periodMs]);

  useEffect(() => {
    if (!totalVariants) {
      return;
    }

    setIndex(startIndex % totalVariants);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startIndex, totalVariants]);

  return index;
};
